import Swiper from "swiper/swiper-bundle.min";
import 'swiper/swiper-bundle.min.css';
import './index.sass';
import './illustration-details';
import './illustration-comments';

export default () => {
  $('.js-favorite-remove-button').on('click', function() {
    var $this;
    $this = $(this);
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')},
        data: {
            _method: 'delete'
        },
        error: function(jqXHR, textStatus, errorThrown) {
            return alert(textStatus);
        },
        success: function(data, textStatus, jqXHR) {
            var $icon;
            $icon = $this.closest('.illustration-page__controls').find('.controls .js-favorite-remove-button');
            $icon.removeClass('js-favorite-remove-button button-favorite-active');
            return $icon.addClass('js-favorite-add-illustration');
        }
    });
  });

  $('.button-favorite.js-favorite-add-illustration').on('click', function() {
    var $this;
    $this = $(this);
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')},
        data: {
            _method: 'post'
        },
        error: function(jqXHR, textStatus, errorThrown) {
            return alert(textStatus);
        },
        success: function(data, textStatus, jqXHR) {
            var $icon;
            $icon = $this.closest('.illustration-page__controls').find('.controls .js-favorite-add-illustration');
            $icon.removeClass('js-favorite-add-illustration');
            return $icon.addClass('js-favorite-remove-button button-favorite-active');
        }
    });
  });
  const $root = $('.js-illustrations-slider');
  const currentSlideIndex = $root.find('.illustration-page__slide--current').index();

  if($root.length > 0) {
    const loop = $root.find('.illustration-page__slide').length > 7 ? true : false

    const mySwiper = new Swiper('.illustration-page__slider-container', {
      spaceBetween: 15,
      initialSlide: currentSlideIndex,
      loop: loop,
      lazy: true,
      preloadImages: false,
      slidesPerGroup: 7,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.illustration-page__slide-next',
        prevEl: '.illustration-page__slide-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        480: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        640: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1240: {
          slidesPerView: 7,
        }
      },
    });

    mySwiper.lazy.load();
  }
}
